import { get, isEmpty } from 'lodash';
import { RECURRING_NONE_OPTION } from './constants';

export const getDefaultRecurringOptionId = (recurringOptions = []) => {
    const recurringOption = getDefaultRecurringOption(recurringOptions);

    return get(recurringOption, 'id');
};

export const getDefaultRecurringOption = (recurringOptions = []) => {
    const [recurringOption] = recurringOptions;

    return recurringOption;
};

export const isNoneRecurringOption = (recurringOptionId) =>
    recurringOptionId === RECURRING_NONE_OPTION.id;

/**
 * Returns only the recurring options that have a discount
 * @param {array} recurringOptions the recurring options
 * @returns {array} the recurringOptions that have a discount
 */
const getRecurringOptionsWithDiscount = (recurringOptions) =>
    recurringOptions.filter(({ discountPercentage }) => discountPercentage);

/**
 * Choose the discountPercentage of a recurring option, according to comparator function
 * @param {array} recurringOptions the recurring options
 * @param {function(a,b): boolean} compare return true if should choose `a` over `b`
 * @returns {number} the minimal discount
 */
const getComparatorDiscount = ({
    recurringOptions,
    compare
}) => {
    const recurringOptionsWithDiscount = getRecurringOptionsWithDiscount(recurringOptions);

    if (isEmpty(recurringOptionsWithDiscount)) {
        return 0;
    }

    const selectedOption = recurringOptionsWithDiscount.reduce(
        (prev, curr) => compare(prev.discountPercentage, curr.discountPercentage) ? prev : curr
    );

    return selectedOption.discountPercentage;
};

/**
 * Return the minimal discount in recurring options
 * @param {array} recurringOptions the recurring options
 * @returns {number} the minimal discount
 */
export const getMinDiscount = (recurringOptions = []) => getComparatorDiscount({
    recurringOptions,
    compare: (prevDiscount, currDiscount) => prevDiscount < currDiscount
});

/**
 * Return the maximal discount in recurring options
 * @param {array} recurringOptions the recurring options
 * @returns {number} the maximal discount
 */
export const getMaxDiscount = (recurringOptions = []) => getComparatorDiscount({
    recurringOptions,
    compare: (prevDiscount, currDiscount) => prevDiscount > currDiscount
});
